import axiosInstance from "./axios.instance";

const API_ADD_CAMPAIGN = async (campaignData) => {
  try {
    const resp = await axiosInstance.post(`/campaign`, campaignData);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

export {
  API_ADD_CAMPAIGN,
}